import { defineMessages } from 'react-intl'

export default defineMessages({
  all: {
    id: 'data.genders.all',
    defaultMessage: 'Any gender',
  },
  male: {
    id: 'data.genders.male',
    defaultMessage: 'Male',
  },
  female: {
    id: 'data.genders.female',
    defaultMessage: 'Female',
  },
  'non-binary': {
    id: 'data.genders.non-binary',
    defaultMessage: 'Non binary',
  },
  allURL: {
    id: 'data.genders.all.url',
    defaultMessage: 'all',
  },
  maleURL: {
    id: 'data.genders.male.url',
    defaultMessage: 'male',
  },
  femaleURL: {
    id: 'data.genders.female.url',
    defaultMessage: 'female',
  },
  'non-binaryURL': {
    id: 'data.genders.non-binary.url',
    defaultMessage: 'non-binary',
  },
})
